/* eslint-disable @calm/react-intl/missing-formatted-message */
import React from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(----spacing-05);
  padding: var(--spacing-05);
  background-color: var(--white-100);
  box-shadow: 0px 3.2px 7.2px rgba(0, 0, 0, 0.13),
    0px 0.6px 1.8px rgba(0, 0, 0, 0.11);
  width: 175px;
`;

const Header = styled.h1`
  font-family: var(--font-family) !important;
  font-size: var(--font-size-base) !important;
  font-weight: var(--font-weight-bold) !important;
  line-height: var(--line-height-body-short-02) !important;
  white-space: initial;
`;

const Info = styled.p`
  max-width: 175px;
  font-family: var(--font-family) !important;
  font-size: var(--font-size-base) !important;
  font-weight: var(--heading-5-weight) !important;
  line-height: var(--line-height-body-short-02) !important;
  white-space: initial;
  overflow-wrap: break-word;
  text-overflow: initial;
`;

const RedText = styled(Info)`
  color: var(--red-60);
`;
const GreenText = styled(Info)`
  color: var(--green-60);
`;

const Footer = styled.p`
  color: var(--black-100);
  opacity: 0.5;
  font-family: var(--font-family);
  font-family: var(--font-family);
  font-weight: var(--heading-5-weight);
  font-size: var(--font-size-base);
  line-height: var(--line-height-body-short-02);
`;

interface Props {
  title: string;
  subTitle?: string;
  delayedBy: number;
  time?: string;
}
export const TemplateInsightTooltip = ({
  title,
  subTitle,
  delayedBy,
  time,
}: Props): string => {
  return renderToStaticMarkup(
    <Wrapper>
      <div>
        <Header>{title}</Header>
        <Info>{subTitle}</Info>
        <RedText>
          {delayedBy > 0 && `Delayed by ${delayedBy} days on average`}
        </RedText>
        <GreenText>
          {delayedBy < 0 && `Early by ${-1 * delayedBy} days on average`}
        </GreenText>
      </div>
      {time && <Footer>{time}</Footer>}
    </Wrapper>,
  );
};

export const TemplateOverviewTooltip = ({
  series,
  title,
}: {
  series: Array<{ name: string; percent: number; val: number }>;
  title: string;
}) => {
  return renderToStaticMarkup(
    <Wrapper>
      <Header>{title}</Header>
      <div>
        {series.map((data) => (
          <Info>
            {data.name}: {data.percent}% ({data.val})
          </Info>
        ))}
      </div>
    </Wrapper>,
  );
};

export const TooltipStyle = {
  useHTML: true,
  borderWidth: 0,
  backgroundColor: 'transparent',
  shadow: false,
};
